import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UnitMeasureService } from '../../../unit-measure.service';
import {
  IUnitMeasureUpdate,
  UNIT_MEASURE_GROUP_TTL_ES
} from '../../../unit-measure.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-unit-measure-update',
  templateUrl: './unit-measure-update.component.html'
})
export class UnitMeasureUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  constructor(
    private fb: FormBuilder,
    private serviceBase: UnitMeasureService
  ) {
    super(UNIT_MEASURE_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    const item = this.row;
    this.fg = this.fb.group({
      description: [
        item.description,
        [Validators.required, Validators.minLength(3), Validators.maxLength(50)]
      ],
      symbol: [
        item.symbol,
        [Validators.required, Validators.minLength(3), Validators.maxLength(10)]
      ]
    });
  }

  onSubmit() {
    this.updateItem$(this.fg.value as IUnitMeasureUpdate);
  }
}
